<template>
  <div class="code-list">
    <order-card title="核销二维码">
      <!-- 03已办理、07作业结束，二维码核销成功 -->
      <div v-if="taskStatus === 'TAKE' || taskStatus === 'WORK_END' || orderStatus === 'CANCEL'">
        <div class="status-view" v-if="taskStatus === 'TAKE' || taskStatus === 'WORK_END'">
          <img class="picture" src="@/assets/img/icon_comp.png" alt="" />
          <div>已成功核销</div>
        </div>
        <!-- 08订单取消，二维码失效 -->
        <div class="status-view" v-if="orderStatus === 'CANCEL'">
          <img class="picture" src="@/assets/img/icon_note.png" alt="" />
          <div>核销码已失效</div>
        </div>
      </div>

      <div v-else>
        <!-- 有二维码加载二维码 -->
        <div v-if="qrCodeInfo && qrCodeInfo.qrcodeUrl">
          <div class="box" v-if="qrCodeSuccess">
            <div @click="showPopup">
              <img id="qrCodeImg" class="picture" :src="qrCodeInfo.qrcodeUrl" alt="" />
            </div>
            <div class="picture-bottom">服务完毕后出示二维码</div>
            <div class="bottom" @click="salesRoom">查看可用门店</div>
            <van-popup v-model="show" class="lift">
              <img class="img" :src="qrCodeInfo.qrcodeUrl" alt="" />
              <div class="picture-bottom-top">服务完毕后出示二维码</div>
            </van-popup>
          </div>
          <!-- 二维码加载失败 -->
          <div class="status-view" v-else>
            <img class="picture" src="@/assets/img/icon_note.png" alt="" />
            <div>核销二维码获取失败</div>
            <div class="service">
              请联系客服<a style="color: #5f2689" :href="'tel:' + phone">{{
                phoneTxt
              }}</a>
            </div>
          </div>
        </div>
        <!-- 二维码未生成 -->
        <div class="status-view" v-else>
          <img class="picture" src="@/assets/img/icon_note.png" alt="" />
          <div>二维码暂未生成</div>
          <div class="service">
            请联系客服<a style="color: #5f2689" :href="'tel:' + phone">{{ phoneTxt }}</a>
          </div>
        </div>
      </div>
    </order-card>
  </div>
</template>

<script>
import OrderCard from "./order-card.vue";
import { ZBServicePhone } from "@/common/constant.js";

export default {
  components: {
    OrderCard,
  },

  props: {
    orderStatus: {
      type: String,
      default: "",
    },
    taskStatus: {
      type: String,
      default: "",
    },
    qrCodeInfo: {
      type: Object,
      default: () => {},
    },
    productCategoryType: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      show: false,
      phone: ZBServicePhone.number,
      phoneTxt: ZBServicePhone.text,
      qrCodeSuccess: true, //二维码加载成功
    };
  },

  mounted() {},

  methods: {
    // 点击放大二维码
    showPopup() {
      this.show = true;
    },

    // 点击跳转门店列表
    salesRoom() {
      this.$router.push({name:"storeList",
        query: {
          productCategoryType: this.productCategoryType,
        },
      });
    },
  },
  created() {
    this.qrCodeSuccess = true;
    const _this = this;
    // 监听图片加载失败
    document.addEventListener(
      "error",
      function (e) {
        var elem = e.target;
        if (elem.id == "qrCodeImg") {
          _this.qrCodeSuccess = false;
        }
      },
      true
    );
  },
};
</script>

<style lang="less" scoped>
.line-wrapper {
  height: 58px;
  color: var(--theme-color);
}
.code-list {
  font-family: PingFangSC-Regular;

  .loading {
    text-align: center;
    font-size: 30px;
    color: var(--theme-color);
  }

  .box {
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    align-items: center;

    .picture {
      height: 200px;
      width: 200px;
      margin: auto;
    }

    .picture-bottom {
      font-size: 14px;
      margin-top: 12px;
      color: #383838;
    }

    .bottom {
      font-size: 13px;
      margin-top: 15px;
      width: 120px;
      height: 23px;
      background: var(--theme-color);
      border-radius: 14px;
      text-align: center;
      color: #ffffff;
      line-height: 23px;
    }

    .lift {
      display: flex;
      align-items: center;
      flex-direction: column;
      border-radius: 5px;
      height: 6.48rem;
      width: 6.9rem;

      .img {
        height: 5rem;
        width: 5rem;
        margin-top: 0.5rem;
      }

      .picture-bottom-top {
        font-size: 14px;
        margin-top: 12px;
        color: #383838;
      }
    }
  }

  .status-view {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 15px;
    color: #666666;

    .picture {
      height: 90px;
      width: 90px;
      margin: auto;
    }

    .service {
      margin-top: 4px;
    }
  }
}
</style>
